var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editable-cell2"
  }, [_c("div", {
    staticClass: "editable-cell-input-wrapper"
  }, [_c("a-form-model-item", [_c("a-input", _vm._b({
    class: {
      "has-error": _vm.err,
      alignRight: _vm.align == "right",
      alignLeft: _vm.align == "left"
    },
    attrs: {
      value: _vm.value
    },
    on: {
      change: _vm.handleChange,
      pressEnter: _vm.check
    }
  }, "a-input", _vm.$attrs, false)), _vm.err ? _c("div", {
    staticClass: "err",
    staticStyle: {
      "line-height": "12px"
    }
  }, [_vm._v(" " + _vm._s(_vm.errContent ? _vm.errContent : _vm.$t("public.enterPlease")) + " ")]) : _vm._e()], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };